export default __webpack_public_path__ + "static/media/ImageStandardCourse.d1ae2730.png";